<template>
  <lazy-growth-contact-dialog-email
    v-if="emailModalOpen"
    v-model="emailModalOpen"
    :origin="origin"
    @submit="onEmailSubmit"
  />

  <lazy-growth-contact-dialog-additional-info
    v-if="additionalInfoModalOpen"
    v-model="additionalInfoModalOpen"
    :origin="origin"
    @submit="onAdditionalInfoSubmit"
  />
</template>

<script lang="ts" setup>
import type { ContactFlowOriginPage } from "~~/model/analytics.model";

const properties = defineProps<{
  origin: ContactFlowOriginPage;
  modelValue: boolean;
  emailOnly?: boolean;
  additionalInfoOnly?: boolean;
}>();

const emit = defineEmits(["submit"]);

const open = useVModel(properties, "modelValue");

const emailModalOpen = ref(open.value && !properties.additionalInfoOnly);
const additionalInfoModalOpen = ref(properties.additionalInfoOnly);

const onEmailSubmit = () => {
  if (properties.emailOnly) return emit("submit");

  additionalInfoModalOpen.value = true;
};

const onAdditionalInfoSubmit = () => {
  emit("submit");
};

whenever(
  () => !emailModalOpen.value && !additionalInfoModalOpen.value,
  () => {
    open.value = false;
  },
);
</script>
